import Vue from 'vue';
import NotificacaoModel from "@/models/notificacao.model";
import store from '@/store';
import {MapActionsSnackbarModule} from "@/store/modules/snackbar/map-actions.snackbar";

class NotificacaoService {

    STATUS_OK: number = 200;

    async getNotificacoesUsuario(idUsuario: number): Promise<any> {
        return await Vue.prototype.$axios.get(`notificacoes/usuario/${idUsuario}`)
            .then((response: any) => {
                const retorno: Array<NotificacaoModel> = response.data;
                return retorno;
            })
            .catch((error: any) => {
                console.error(error.response);
            });
    }

    async marcarComoLido(idNotificacao: number): Promise<any> {
        return await Vue.prototype.$axios.put(`notificacoes/marcar-lida/${idNotificacao}`)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS,
                        'A notificação foi marcada como lida ;)');
                    return true;
                } else {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR,
                        'Falha ou marcar notificação como lida ;(');
                    return false;
                }
            })
            .catch((error: any) => {
                console.error(error.response);
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR,
                    'Falha ou marcar notificação como lida ;(');
                return false;
            });
    }

    async deletarNotificacao(idNotificacao: number): Promise<any> {
        return await Vue.prototype.$axios.delete(`notificacoes/${idNotificacao}`)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS,
                        'A notificação foi deletada ;)');
                    return true;
                } else {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR,
                        'Falha ou deletar notificação ;(');
                    return false;
                }
            })
            .catch((error: any) => {
                console.error(error.response);
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR,
                    'Falha ou deletar notificação ;(');
                return false;
            });
    }

}

export default new NotificacaoService();
